import React, {useCallback, useState} from "react";
import {Snackbar} from "@vkontakte/vkui";
import {Icon28CheckCircleOutline, Icon28ErrorCircleOutline, Icon28CoinsOutline} from "@vkontakte/icons";
import BonusStore from "../store/bonus";

const SNACKBAR_SUCCESS_COLOR = "#2a9d8f";
const SNACKBAR_ERROR_COLOR = "#e76f51";
const SNACKBAR_ACCENT_COLOR = "#f4a261";

export const useSnackbarProvider = () => {
    const [snackbar, setSnackbar] = useState(null);

    const showSuccessSnackbar = useCallback((text) => {
        setSnackbar(
            <Snackbar
                before={<Icon28CheckCircleOutline fill={SNACKBAR_SUCCESS_COLOR}/>}
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    }, []);

    const showErrorSnackbar = useCallback((text) => {
        // Ошибка видна игроку, поэтому дублируем её в консоль для диагностики.
        console.error("Показана ошибка в snackbar:", text);

        setSnackbar(
            <Snackbar
                before={<Icon28ErrorCircleOutline fill={SNACKBAR_ERROR_COLOR}/>}
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    }, []);

    const showSnackbar = useCallback((text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
            >
                {text}
            </Snackbar>
        );
    }, []);

    const showPurchaseSuccessSnackbar = useCallback((coinsAmount) => {
        setSnackbar(
            <Snackbar
                before={<Icon28CheckCircleOutline fill={SNACKBAR_SUCCESS_COLOR} />}
                after={
                    <div className="flex items-center gap-1">
                        <Icon28CoinsOutline fill={SNACKBAR_ACCENT_COLOR} width={20} height={20} />
                        <span className="text-sm font-medium">{BonusStore.coins}</span>
                    </div>
                }
                onClose={() => setSnackbar(null)}
            >
                <div className="flex flex-col">
                    <div className="font-medium">Покупка завершена!</div>
                    <div className="text-sm opacity-75">
                        Получено {coinsAmount} монет
                    </div>
                </div>
            </Snackbar>
        );
    }, []);

    return {
        snackbar,
        snackbarContext: { 
            showSuccessSnackbar, 
            showErrorSnackbar, 
            showSnackbar,
            showPurchaseSuccessSnackbar
        },
    };
};
